import { FC } from 'react';
import { getWithThousandsSeparator } from 'framework/utils';
import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
import { Typography } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';

interface AmountSensitiveFieldProps extends FieldProps {
  showContent?: boolean;
  currencySource?: string;
  tooltipText?: string;
}

const AmountSensitiveField: FC<AmountSensitiveFieldProps> = ({
  showContent,
  currencySource,
  tooltipText,
  ...restProps
}) => {
  const { getValue } = useFieldHelper<FieldProps>({ source: restProps.source });
  const { getValue: getCurrency } = useFieldHelper({ source: currencySource });

  if (!showContent) {
    return <Typography>*****</Typography>;
  }

  const value = getValue();
  const isObject = value && typeof value === 'object';
  const rawAmount = isObject ? value.amount : value;
  const currency = getCurrency() || (isObject ? value.currency : null);

  const formattedAmount =
    rawAmount || rawAmount === 0 ? `${getWithThousandsSeparator(rawAmount)} ${currency || ''}`.trim() : null;

  const content = <TextField {...restProps} source="amount" value={formattedAmount} />;

  return tooltipText && formattedAmount ? (
    <Tooltip title={tooltipText}>
      <span>{content}</span>
    </Tooltip>
  ) : (
    content
  );
};

export default AmountSensitiveField;
